export const CATEGORY_COLOR_MUSTARD_900 = '#DB900A';
export const CATEGORY_COLOR_MUSTARD_800 = '#E19F12';
export const CATEGORY_COLOR_MUSTARD_700 = '#E4A717';
export const CATEGORY_COLOR_MUSTARD_600 = '#E7B01B';
export const CATEGORY_COLOR_MUSTARD_500 = '#EAB71F';
export const CATEGORY_COLOR_MUSTARD_400 = '#EDC241';
export const CATEGORY_COLOR_MUSTARD_300 = '#F0CD62';
export const CATEGORY_COLOR_MUSTARD_200 = '#F5DB8F';
export const CATEGORY_COLOR_MUSTARD_100 = '#F9E9BC';
export const CATEGORY_COLOR_MUSTARD_50 = '#FCF6E4';

export const CATEGORY_COLOR_MUSTARD_500_8P = 'rgba(234, 183, 31, 0.08)';
export const CATEGORY_COLOR_MUSTARD_500_16P = 'rgba(234, 183, 31, 0.16)';
export const CATEGORY_COLOR_MUSTARD_500_24P = 'rgba(234, 183, 31, 0.24)';
export const CATEGORY_COLOR_MUSTARD_500_32P = 'rgba(234, 183, 31, 0.32)';
export const CATEGORY_COLOR_MUSTARD_500_40P = 'rgba(234, 183, 31, 0.40)';
export const CATEGORY_COLOR_MUSTARD_500_48P = 'rgba(234, 183, 31, 0.48)';

export const CATEGORY_COLOR_TANGERINE_900 = '#DB5125';
export const CATEGORY_COLOR_TANGERINE_800 = '#E16434';
export const CATEGORY_COLOR_TANGERINE_700 = '#E46E3D';
export const CATEGORY_COLOR_TANGERINE_600 = '##E77946';
export const CATEGORY_COLOR_TANGERINE_500 = '#EA814D';
export const CATEGORY_COLOR_TANGERINE_400 = '#ED9468';
export const CATEGORY_COLOR_TANGERINE_300 = '#F0A782';
export const CATEGORY_COLOR_TANGERINE_200 = '#F5C0A6';
export const CATEGORY_COLOR_TANGERINE_100 = '#F9D9CA';
export const CATEGORY_COLOR_TANGERINE_50 = '#FCF0EA';

export const CATEGORY_COLOR_TANGERINE_500_8P = 'rgba(234, 129, 77, 0.08)';
export const CATEGORY_COLOR_TANGERINE_500_16P = 'rgba(234, 129, 77, 0.16)';
export const CATEGORY_COLOR_TANGERINE_500_24P = 'rgba(234, 129, 77, 0.24)';
export const CATEGORY_COLOR_TANGERINE_500_32P = 'rgba(234, 129, 77, 0.32)';
export const CATEGORY_COLOR_TANGERINE_500_40P = 'rgba(234, 129, 77, 0.40)';
export const CATEGORY_COLOR_TANGERINE_500_48P = 'rgba(234, 129, 77, 0.48)';

export const CATEGORY_COLOR_LAVENDER_900 = '#4E3C94';
export const CATEGORY_COLOR_LAVENDER_800 = '#614DA3';
export const CATEGORY_COLOR_LAVENDER_700 = '#6B57AB';
export const CATEGORY_COLOR_LAVENDER_600 = '#7662B3';
export const CATEGORY_COLOR_LAVENDER_500 = '#7E6ABA';
export const CATEGORY_COLOR_LAVENDER_400 = '#9180C4';
export const CATEGORY_COLOR_LAVENDER_300 = '#A597CF';
export const CATEGORY_COLOR_LAVENDER_200 = '#BFB5DD';
export const CATEGORY_COLOR_LAVENDER_100 = '#D8D2EA';
export const CATEGORY_COLOR_LAVENDER_50 = '#F0EDF7';

export const CATEGORY_COLOR_LAVENDER_500_8P = 'rgba(126, 106, 186, 0.08)';
export const CATEGORY_COLOR_LAVENDER_500_16P = 'rgba(126, 106, 186, 0.16)';
export const CATEGORY_COLOR_LAVENDER_500_24P = 'rgba(126, 106, 186, 0.24)';
export const CATEGORY_COLOR_LAVENDER_500_32P = 'rgba(126, 106, 186, 0.32)';
export const CATEGORY_COLOR_LAVENDER_500_40P = 'rgba(126, 106, 186, 0.40)';
export const CATEGORY_COLOR_LAVENDER_500_48P = 'rgba(126, 106, 186, 0.48)';

export const CATEGORY_COLOR_DENIM_900 = '#124B8A';
export const CATEGORY_COLOR_DENIM_800 = '#1D5E99';
export const CATEGORY_COLOR_DENIM_700 = '#2368A2';
export const CATEGORY_COLOR_DENIM_600 = '#2973AB';
export const CATEGORY_COLOR_DENIM_500 = '#2E7BB3';
export const CATEGORY_COLOR_DENIM_400 = '#4D8FBE';
export const CATEGORY_COLOR_DENIM_300 = '#6DA3C9';
export const CATEGORY_COLOR_DENIM_200 = '#97BDD9';
export const CATEGORY_COLOR_DENIM_100 = '#C0D7E8';
export const CATEGORY_COLOR_DENIM_50 = '#E6EFF6';

export const CATEGORY_COLOR_DENIM_500_8P = 'rgba(46, 123, 178, 0.08)';
export const CATEGORY_COLOR_DENIM_500_16P = 'rgba(46, 123, 178, 0.16)';
export const CATEGORY_COLOR_DENIM_500_24P = 'rgba(46, 123, 178, 0.24)';
export const CATEGORY_COLOR_DENIM_500_32P = 'rgba(46, 123, 178, 0.32)';
export const CATEGORY_COLOR_DENIM_500_40P = 'rgba(46, 123, 178, 0.40)';
export const CATEGORY_COLOR_DENIM_500_48P = 'rgba(46, 123, 178, 0.48)';

export const CATEGORY_COLOR_LIME_900 = '#0F5713';
export const CATEGORY_COLOR_LIME_800 = '#196A1F';
export const CATEGORY_COLOR_LIME_700 = '#1F7426';
export const CATEGORY_COLOR_LIME_600 = '#257F2D';
export const CATEGORY_COLOR_LIME_500 = '#2A8732';
export const CATEGORY_COLOR_LIME_400 = '#4A9951';
export const CATEGORY_COLOR_LIME_300 = '#6AAB70';
export const CATEGORY_COLOR_LIME_200 = '#95C399';
export const CATEGORY_COLOR_LIME_100 = '#BFDBC2';
export const CATEGORY_COLOR_LIME_50 = '#E5F1E6';

export const CATEGORY_COLOR_LIME_500_8P = 'rgba(42, 135, 50, 0.08)';
export const CATEGORY_COLOR_LIME_500_16P = 'rgba(42, 135, 50, 0.16)';
export const CATEGORY_COLOR_LIME_500_24P = 'rgba(42, 135, 50, 0.24)';
export const CATEGORY_COLOR_LIME_500_32P = 'rgba(42, 135, 50, 0.32)';
export const CATEGORY_COLOR_LIME_500_40P = 'rgba(42, 135, 50, 0.40)';
export const CATEGORY_COLOR_LIME_500_48P = 'rgba(42, 135, 50, 0.48)';

export const CATEGORY_COLOR_RUBY_900 = '#BC1A2B';
export const CATEGORY_COLOR_RUBY_800 = '#C6273C';
export const CATEGORY_COLOR_RUBY_700 = '#CC2E45';
export const CATEGORY_COLOR_RUBY_600 = '#D1364F';
export const CATEGORY_COLOR_RUBY_500 = '#D63C56';
export const CATEGORY_COLOR_RUBY_400 = '#DC596F';
export const CATEGORY_COLOR_RUBY_300 = '#E27789';
export const CATEGORY_COLOR_RUBY_200 = '#EB9EAB';
export const CATEGORY_COLOR_RUBY_100 = '#F3C5CC';
export const CATEGORY_COLOR_RUBY_50 = '#FAE8EB';

export const CATEGORY_COLOR_RUBY_500_8P = 'rgba(214, 60, 86, 0.08)';
export const CATEGORY_COLOR_RUBY_500_16P = 'rgba(214, 60, 86, 0.16)';
export const CATEGORY_COLOR_RUBY_500_24P = 'rgba(214, 60, 86, 0.24)';
export const CATEGORY_COLOR_RUBY_500_32P = 'rgba(214, 60, 86, 0.32)';
export const CATEGORY_COLOR_RUBY_500_40P = 'rgba(214, 60, 86, 0.40)';
export const CATEGORY_COLOR_RUBY_500_48P = 'rgba(214, 60, 86, 0.48)';
